import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles((theme) => ({
  scrollContainer: {
    margin: '0px 0px',
  },
}));
